import { Trash } from "@phosphor-icons/react";
import { type ReactElement, useState } from "react";

import DesktopActions from "common/components/DesktopActions";
import MobileActions from "common/components/MobileActions";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { ActionsType } from "common/types";

import DeleteSource from "./DeleteSource";

interface SourceActionsProps {
  listId: string;
  sourceId: string;
  children: ReactElement;
}

export default function SourceActions({
  listId,
  sourceId,
  children,
}: SourceActionsProps) {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);

  const editOptions = {
    delete: { icon: Trash, label: "Delete source", isDanger: true },
  } satisfies ActionsType;

  function renderAction(onBack: () => void, onClose: () => void) {
    return (
      <DeleteSource
        listId={listId}
        sourceId={sourceId}
        onBack={onBack}
        onClose={onClose}
      />
    );
  }

  if (isDesktop) {
    return (
      <DesktopActions triggerElement={children} editOptions={editOptions}>
        {(_, onClose) => renderAction(onClose, onClose)}
      </DesktopActions>
    );
  }

  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen}>
      <DrawerTrigger asChild>{children}</DrawerTrigger>

      <DrawerContent>
        <MobileActions editOptions={editOptions} editTitle="Source actions">
          {(_, onBack) => renderAction(onBack, () => setIsOpen(false))}
        </MobileActions>
      </DrawerContent>
    </Drawer>
  );
}
